import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { EMPTY, of } from 'rxjs';
import { FeatureToggleService } from '../../shared/services/feature-toggle/feature-toggle.service';
import { EntitlementsService } from '../../entitlements/entitlements.service';
import { LegalEntitiesService } from '../../services/legal-entities.service';
import { SettingsService } from '../../shared/services/settings/settings.service';
import { AppRoutes } from '../../shared/constants/app-routes';

@Component({
  selector: 'ssg-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.less']
})
export class DashboardComponent implements OnInit {

  showDashboard = false;

  constructor(
    private readonly router: Router,
    private readonly featureToggleService: FeatureToggleService,
    private readonly entitlementsService: EntitlementsService,
    private readonly legalEntitiesService: LegalEntitiesService,
    private readonly settingsService: SettingsService
  ) { }

  ngOnInit(): void {
    this.legalEntitiesService.getLegalEntities(this.settingsService.tenantId).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 403) {
          this.router.navigate([{outlets: { eepay: [AppRoutes.UnauthorizedQualifiers]}}]);
          return EMPTY;
        }
        // For other error codes, do not block the dashboard
        return of(null);
      })
    ).subscribe(() => {
      this.showDashboard = true;
    });
  }

  get showAlerts() {
    return this.featureToggleService.isFeatureEnabled('enableAlertsAndNotifications')
        && !this.featureToggleService.isFeatureEnabled('enableHomeAlertsNotifications')
        && this.entitlementsService.isEntitled(['ViewCuiAlertsAndNotifications']);
  }

  get showQuickActions() {
    return this.featureToggleService.isFeatureEnabled('enableQuickActions')
        && this.entitlementsService.isEntitled(['ViewCuiQuickActions']);
  }

  get showAtAGlance() {
    return this.entitlementsService.isEntitled(['ViewCuiAtAGlance']);
  }
}
